import {callLambda} from '@/lib/api/lambda';

/**
 * getAiResponse 取得 AI 教練的回應
 * @param {Object} data 請求資料
 * @param {String} data.text 使用者輸入的文字
 * @param {String} data.coursePlan 選填，使用者選擇的課程計畫
 */
async function getAiResponse(data) {
  return callLambda({
    category: 'ai',
    method: 'post',
    apiName: 'ai-tutor',
    data,
  }).then((res) => {
    return res.data;
  });
}

/**
 * postChatbot2c 取得 AI 教練的回應
 * @param {String} text 使用者輸入的文字
 */
export async function postChatbot2c(text) {
  return callLambda({
    category: 'ai',
    method: 'post',
    apiName: 'chatbot',
    data: {
      text,
      dataset: '2C', // 2B or 2C
    },
  }).then((res) => {
    return res.data;
  });
}

/**
 * postChatbot2b 取得 AI 教練的回應
 * @param {String} text 使用者輸入的文字
 */
export async function postChatbot2b(text) {
  return callLambda({
    category: 'ai',
    method: 'post',
    apiName: 'chatbot',
    data: {
      text,
      dataset: '2B', // 2B or 2C
    },
  }).then((res) => {
    return res.data;
  });
}

/**
 * upsertAiRecord
 * @param {String} dataset: '2B' | '2C'
 * @param {Number} time 時間戳記
 * @param {String} contents 使用者輸入的文字
 * @param {Boolean} isLike 是否喜歡 AI 回應
 */
export async function upsertAiRecord({dataset, time, contents, isLike}) {
  return callLambda({
    category: 'ai',
    method: 'post',
    apiName: 'aiRecords',
    data: {
      dataset,
      time,
      contents,
      isLike,
    },
  }).then((res) => {
    return res.data;
  });
}

/**
 * upsertAiRecord2c
 * @param {Object} data data
 * @param {Number} data.time 時間戳記
 * @param {String} data.contents 使用者輸入的文字
 * @param {Boolean} data.isLike 是否喜歡 AI 回應
 */
export async function upsertAiRecord2c(data) {
  return upsertAiRecord({
    dataset: '2C',
    ...data,
  });
}

/**
 * upsertAiRecord2b
 * @param {Object} data data
 * @param {Number} data.time 時間戳記
 * @param {String} data.contents 使用者輸入的文字
 * @param {Boolean} data.isLike 是否喜歡 AI 回應
 */
export async function upsertAiRecord2b(data) {
  return upsertAiRecord({
    dataset: '2B',
    ...data,
  });
}

/**
 * deleteAiRecord 刪除 AI 記錄
 * @param {String} text 使用者輸入的文字
 */
export async function deleteAiRecord({time}) {
  return callLambda({
    category: 'ai',
    method: 'delete',
    apiName: 'aiRecords',
    data: {
      time,
    },
  }).then((res) => {
    return res.data;
  });
}

export default {
  getAiResponse,
  postChatbot2c,
  postChatbot2b,
  upsertAiRecord2c,
  upsertAiRecord2b,
  deleteAiRecord,
};
